import axios from "axios";

export function getClassTimeList(obj) {
    const config = {
        params: obj
    };
    return axios.get(process.env.VUE_APP_API_URL + "ClassDayAndTime/list", config);
}

export function postClassTime(data) {
    return axios.post(process.env.VUE_APP_API_URL + "ClassDayAndTime/add", data);
}

export function updateClassTime(data) {
    return axios.put(process.env.VUE_APP_API_URL + "ClassDayAndTime/update", data);
}

export function deleteClassTime(classDayAndTimeId) {
    const config = {
        params: {
            classDayAndTimeId: classDayAndTimeId,
        },
    };
    return axios.delete(process.env.VUE_APP_API_URL + "ClassDayAndTime/deleted", config);
}
